import { render, staticRenderFns } from "./appDownInfo.vue?vue&type=template&id=87a64d26&scoped=true"
import script from "./appDownInfo.vue?vue&type=script&lang=js"
export * from "./appDownInfo.vue?vue&type=script&lang=js"
import style0 from "./appDownInfo.vue?vue&type=style&index=0&id=87a64d26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87a64d26",
  null
  
)

export default component.exports